

document.addEventListener("DOMContentLoaded", function(){
    // function to change color cart fixed button when add product to cart
  const buttonAddToCart = document.querySelector("#ProductSubmitButtonContainer button");
  const cartFixedButton = document.getElementsByClassName("cart-count-footer")[0];;
  console.log('boton azul' + buttonAddToCart);
  if (buttonAddToCart != null) {
  	
  	buttonAddToCart.addEventListener("click",function(e){
      
      cartFixedButton.classList.add("blue-active"); 
      	     
  	},false);
  }

  footerSubscribe();
});

function footerSubscribe() {
  const subscribeBtn = document.querySelector('.newsletter-form__button');
  const subscribeEmail = document.querySelector('.newsletter-form__field-wrapper input.field__input');

  const mcBtn = document.querySelector('#mc_embed_shell #mc_embed_signup #mc-embedded-subscribe');
  const mcInput = document.querySelector('#mc_embed_shell #mc_embed_signup input#mce-EMAIL');

  if (subscribeBtn) {
    subscribeBtn.addEventListener('click', (e) => {
      e.preventDefault();

      if (mcInput) {
        mcInput.value = subscribeEmail.value;
      }

      if (mcBtn) mcBtn.click();

      setTimeout(() => {
        const multiItems = document.querySelectorAll('.newsletter__wrapper .is-clone-class');
        multiItems.forEach(item => {
          document.querySelector('.newsletter__wrapper').removeChild(item);  
        });

        const mcResponse = document.querySelector('#mc_embed_shell #mce-responses');

        if (mcResponse) {
          const successMsg = mcResponse.querySelector('#mce-success-response');
          const failedMsg = mcResponse.querySelector('#mce-error-response');

          if (successMsg.style.display == 'block') {
            successMsg.innerHTML = 'SUBSCRIBED';
          } else if (failedMsg.style.display == 'block') {
            failedMsg.innerHTML = 'NOT SUBSCRIBED';
          }
          const cloneElement = mcResponse.cloneNode(true);
          cloneElement.classList.add('is-clone-class');

          document.querySelector('.newsletter__wrapper').append(cloneElement);
        }
      }, 2500);
    })
  }
}